import { CSSObject } from "@emotion/react";
import {
  type AnchorStyleOverrides,
  constants,
  typographyStyles,
} from "@newsela/angelou";

export const standardCardRelativeCss: CSSObject = {
  position: "relative",
  borderRadius: "1rem",
};

export const standardCardContainerCss: CSSObject = {
  display: "flex",
  height: "100%",
  flexDirection: "column",
  padding: "1rem 0.75rem",
  gap: "0.25rem",
  borderRadius: "1rem",
  background: constants.colors.ui.white[50],
};

export const standardCardAnchorCss: AnchorStyleOverrides<CSSObject> = {
  root: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: "1rem",
  },
};

export const standardCardTitleCss = {
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.fontSize.textXS,
  ...typographyStyles.lineHeight.heading6LineHeights,
  lineHeight: typographyStyles.lineHeight.l16SingleValue(0.75),
  color: constants.colors.ui.neutral[600],
  fontWeight: 700,
};

export const standardCardDateCss = {
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.fontSize.textXS,
  ...typographyStyles.lineHeight.heading6LineHeights,
  lineHeight: typographyStyles.lineHeight.l16SingleValue(0.75),
  color: constants.colors.ui.neutral[600],
  fontWeight: 400,
};

export const standardCardCodeCss = {
  ...typographyStyles.fontFamily.noto,
  ...typographyStyles.fontSize.textS,
  lineHeight: typographyStyles.lineHeight.l16SingleValue(0.75),
  color: constants.colors.ui.neutral[700],
  fontWeight: 700,
};

export const standardCardDescriptionCss = {
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.fontSize.textS,
  color: constants.colors.ui.neutral[600],
  lineHeight: typographyStyles.lineHeight.l20SingleValue(0.875),
  fontWeight: 400,
};

export const standardCardGradeLevelsCss = {
  ...typographyStyles.fontFamily.circular,
  ...typographyStyles.fontSize.textXS,
  lineHeight: typographyStyles.lineHeight.l16SingleValue(0.75),
  color: constants.colors.ui.neutral[500],
  letterSpacing: "0.00806rem",
  fontWeight: 700,
};

export const standardBookmarkButtonCss = {
  root: {
    position: "absolute !important",
    background: constants.colors.ui.white[50],
    top: 0,
    right: 0,
    padding: "0.5rem",
    borderRadius: "0 1rem 0 0.5rem",
    borderBottom: `1px solid ${constants.colors.ui.neutral[50]}`,
    borderLeft: `1px solid ${constants.colors.ui.neutral[50]}`,
    zIndex: 1,

    ":hover, :focus": {
      background: constants.colors.ui.white[50],
    },

    svg: {
      width: "1.5rem",
      height: "1.5rem",
    },
  },
};

export const standardCardDatesContainer = {
  display: "flex",
};
